import { useReactiveVar } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import { Container } from 'components/park/styles/styles';
import HslContext from 'context/HslContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { country } from 'states/persistInStorage';
import { StyledWrapper } from 'styles/ContainerStyles';
import { SubscriptionType } from 'types/generatedSchemaTypes';
import { HslParkingStackParamList, ServicesNavProps } from 'types/navigation';
import { currencyFormatter } from 'utils/commonUtils';

const HslSubscriptionSelection: React.FC = () => {
  const { t } = useTranslation();
  const { setSelectedSubscriptionType, hslPricingResult } =
    useContext(HslContext);
  const countryCode = useReactiveVar(country);
  const { navigate } = useNavigation<ServicesNavProps>();
  const { goBack, canGoBack } =
    useNavigation<StackNavigationProp<HslParkingStackParamList>>();

  const handleBack = () => {
    if (canGoBack()) {
      goBack();
    } else {
      navigate('hslNavigator', { screen: 'hslTicket' });
    }
  };

  const selectValue = (subscriptionType: SubscriptionType) => {
    setSelectedSubscriptionType(subscriptionType);
    handleBack();
  };

  const autoSaverPrice = () => {
    return currencyFormatter(
      (hslPricingResult?.data?.readHslTicketPricing?.find(
        (pricing) => pricing?.validityPeriod === 30
      )?.subscriberPrice as number) / 100 || 0,
      countryCode,
      true
    );
  };

  return (
    <Container
      testID="hsl-select-subscription-ticket-container"
      mr={20}
      ml={20}>
      <StyledWrapper mb={5}>
        <MenuItem
          noBorder
          testID={'hsl-subscription-one-off'}
          onPress={() => selectValue('ONEOFF')}
          menuLabel={t('hslTicket.subscriptionTypes.oneoff.title')}
          iconName="Services-Outlined"
          iconFlexStart
          large
          iconMt={5}
          subtitle={t('hslTicket.subscriptionTypes.oneoff.info')}
          background={theme.colors.gray50}
        />
      </StyledWrapper>
      <StyledWrapper mb={5}>
        <MenuItem
          noBorder
          testID={'hsl-subscription-saver'}
          onPress={() => selectValue('AUTOSAVER')}
          menuLabel={t('hslTicket.subscriptionTypes.autosaver.title')}
          iconName="Services-Outlined"
          iconFlexStart
          large
          iconMt={5}
          subtitle={t('hslTicket.subscriptionTypes.autosaver.info', {
            price: autoSaverPrice(),
          })}
          background={theme.colors.gray50}
        />
      </StyledWrapper>
    </Container>
  );
};

export default HslSubscriptionSelection;
